module.exports = __webpack_public_path__ + "8e63908b854f8f397dfe81342795eb1e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Bold-webfont.ttf
// module id = 217
// module chunks = 0